export const blue = '#3e4c94';
